import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Box, Button ,Card, CardBody, CardHeader, Container,
  Flex,
  Heading, HStack,
  IconButton,
  Spinner,
  Text, Textarea, useToast
} from "@chakra-ui/react";
import React, {useEffect, useState}  from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";

//import RenderResource from "./RenderResource";
import { updateCandidateRevision } from "../Api";
import {errorToast, successToast} from "../helper/ToastHelper";
import {useAuthentication} from "../hooks/AuthenticationProvider";
import {useTheme} from "../hooks/ThemeProvider";
import { AnswerPropertyKey, Authority, CandidateStatus, Paths, QuestionType, SkillType } from "../model/Constants";
import { CandidateRevisionDto } from "../model/Dto";
import { adminKeys } from "../QueryKeys";
import { displayCandidateStatus, displayTime, extractData } from "../Utils";
import AudioPlayer from "./AudioPlayer";
import Markdown from "./Markdown";


type JudgeRevisionBoxProps = {
  revision: CandidateRevisionDto;
  readOnly?: boolean;
  displayName?: boolean;
};

const JudgeRevisionBox = (props: JudgeRevisionBoxProps) => {
  const authentication = useAuthentication();
  const toast = useToast();
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const themeContext = useTheme();

  const [levelValue, setLevelValue] = useState<string>("");
  const [descriptionValue, setDescriptionValue] = useState<string>("");

  useEffect(() => {
    if (levelValue === "" && props.revision.level && levelValue !== props.revision.level)
      setLevelValue(props.revision.level);

    if (descriptionValue === "" && props.revision.description &&
        descriptionValue !== props.revision.description)
      setDescriptionValue(props.revision.description);

  }, [props.revision]);

  const updateCandidateRevisionMutation = useMutation(({ username, token, testPublicId, level, description  }: any) =>
      updateCandidateRevision(username, token,testPublicId, level, description),
    {
      onSuccess: () => {
        if (props.revision) {
          props.revision.level = levelValue
          props.revision.description = descriptionValue
        }

        successToast(toast, "Revisión actualizada");
        return queryClient.invalidateQueries(adminKeys.candidates());
      },
      onError: () => {
        errorToast(toast, "Error actualizando revisión");
      },
    });

  function handleSave() {
      updateCandidateRevisionMutation.mutate({
        username: props.revision.candidateUsername,
        token: props.revision.token,
        testPublicId: props.revision.testPublicId,
        level: levelValue,
        description: descriptionValue
      })
  }


    return (
          <Box
            marginTop="2"
            marginBottom="2"
            padding="2"
            borderWidth="1px"
            borderRadius="lg"
            borderColor="gray.300"
            borderStyle="solid"
          >
            { props.displayName===true ?
              <Text>Revisión de {props.revision.judgeName}</Text> :
              <Text>Revisión</Text>
            }
            <HStack>
              <Text>Banda</Text>
              <Textarea value={levelValue} minW="10em" resize="none" maxLength={6} width="auto"
                onChange={(event)=>setLevelValue(event.target.value)}
                rows={1}
                isReadOnly={props.readOnly===true}
              />
            </HStack>

            <HStack>
              <Text>Comentarios</Text>
              <Textarea value={descriptionValue} minW="10em" resize="none" maxLength={5000} width="stretch"
                onChange={(event)=>setDescriptionValue(event.target.value)}
                rows={5}
                isReadOnly={props.readOnly===true}
              />
              { props.displayName!==true && /* isAdmin */
                  <Button
                    marginX={10}
                    colorScheme="teal"
                    type="submit"
                    onClick={() => handleSave()}
                    isDisabled={props.readOnly===true}
                  >
                    Guardar
                  </Button>
              }
            </HStack>

          </Box>

    );

};

export default JudgeRevisionBox;
